import { render, staticRenderFns } from "./hosting-email-forwarders-illustration.vue?vue&type=template&id=db896778"
import script from "./hosting-email-forwarders-illustration.vue?vue&type=script&lang=js"
export * from "./hosting-email-forwarders-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports